export default function ShippingPolicy() {
  return (
    <div style={{ padding: "20px" }}>
      <h2>Shipping & Delivery Policy</h2>
      <p>YShipping & Delivery Policy – Nawabi Bites

Delivery Time

Orders are processed within 24 hours.

Delivery usually takes 2–5 working days depending on location.

Shipping Charges

₹49 standard shipping

Free shipping above ₹499

Order Tracking

Once shipped, tracking details will be shared on SMS/Email.

Delivery Partners

We deliver using trusted couriers:

Delhivery

Bluedart

DTDC

Xpressbees

Packaging

All food products are packed safely in:

Air-tight pouches

Shock-proof outer packaging

Delayed Delivery

If delivery exceeds 7 days, contact us for assistance.</p>
    </div>
  );
}
